import React from 'react';
import { Svg } from 'assets';
import { DateRow, PriceRow } from 'components';
import { ReportTypeEnum, Settings } from 'fragments';

export const PastOrdersCard = (
  {
    order,
    handleDownload,
    handleViewPdf,
    settingsForView,
    settingsForDownload,
    loading,
  }) => {
  return (
    <div className='PastOrdersCard-wrapper'>
      <div className='PastOrdersCard-header'>
        <Svg.DocumentSvg />
        {order?.address?.formattedAddress}
      </div>

      <div className='PastOrdersCard-text-block'>
        <p className='PastOrdersCard-text'>
          Date Paid: <span className='PastOrdersCard-desc'><DateRow date={order?.createdAt} />  </span>
        </p>

        <p className='PastOrdersCard-text'>
          Price: <span className='PastOrdersCard-desc'>
            <PriceRow info={order?.paymentAmount ? +order?.paymentAmount : 0} />
           </span>
        </p>


        <p className='PastOrdersCard-text'>
          Type: <div
          className='PastOrdersCard-order-type'
          style={{
            background: order?.reportType === ReportTypeEnum.FRV ? '#F4F3FF' : order?.reportType === ReportTypeEnum.FMV ? '#EFF8FF' : '#ECFDF3',
            color: order?.reportType === ReportTypeEnum.FRV ? '#5925DC' : order?.reportType === ReportTypeEnum.FMV ? '#175CD3' : '#027A48',
          }}
        >
          {order?.reportType === ReportTypeEnum.ALL ? 'FRV + FMV (Bundle)' : order?.reportType}
        </div>
        </p>
      </div>

      <div className='PastOrdersCard-svgs'>
        <Settings
          list={order?.reportType === ReportTypeEnum.ALL && settingsForView}
          onClick={handleViewPdf}

        />
        <Settings
          list={order?.reportType === ReportTypeEnum.ALL && settingsForDownload}
          onClick={handleDownload}
          MainSvg={Svg.DownloadSvg}
          loading={loading}
          itemStyles={{ width: 159 }}
        />
      </div>
    </div>
  );
};
